export const FIELD_COLOR = '#6c973a3d';
export const UNLOADING_COLOR = '#3771c73d';
export const WAITING_COLOR = '#f17b0b3d';
